"use client";
import { useState } from "react";

interface ProgramListProps {
  cards: Array<{
    title: string;
    subtitle: string;
    description: string;
    postScript?: React.ReactNode; // Може бути JSX або undefined
    time: string;
    descriptionTitle: string;
    descritptionSubtitle: string;
    price: React.ReactNode; // Може бути JSX
  }>;
}

export default function ProgramList({ cards }: ProgramListProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <div data-meta="ProgramList" className="relative flex flex-col">
      {cards.map((card, index) => (
        <div
          id="card"
          key={index}
          className={`relative flex flex-col shadow-sm cursor-pointer transition-transform duration-500 transform-gpu
            ${
              index === cards.length - 1
                ? "border border-white rounded-xl"
                : "rounded-t-xl border-t border-r border-l border-white"
            }
            ${activeIndex === index ? "z-20 scale-105 bg-white" : "z-10"}`}
          onClick={() => setActiveIndex(activeIndex === index ? null : index)}
          style={{
            transform: `translateY(-${index * 24}px)`,
            background:
              "linear-gradient(360deg, rgba(245, 245, 247, 0) 0%, rgba(144, 144, 145, 0.4) 57.92%)",
          }}
        >
          <div
            className={`px-8 pt-8 text-white ${
              activeIndex !== index ? "hover-anomation" : ""
            } ${activeIndex === index ? "pb-8" : "pb-4"}`}
          >
            <div className="flex gap-4 mb-4 justify-between">
              <p className="text-xs md:text-sm">{card.subtitle}</p>
              <div className="whitespace-nowrap max-h-fit text-black leading-4 tracking-wider bg-white rounded-full z-30 px-4 font-bold py-2 text-xs md:text-md uppercase">
                {card.time}
              </div>
            </div>
            <p
              className={`mb-4 text-xl md:text-4xl lg:text-5xl font-semibold pb-2 ${
                activeIndex === index ? "border-b border-white/50" : ""
              }`}
            >
              {card.title}
            </p>
            <style jsx>{`
              .hover-anomation:hover {
                transform: scale(1.04) translateY(-3px);
                z-index: 15;
                transition: transform 0.3s ease-in-out;
              }
            `}</style>
            {cards.length === 1 ? (
              <div
                id="description"
                className={`overflow-hidden mb-8 transition-all duration-300 ease-in-out  max-h-[200px] opacity-100`}
              >
                <p className="text-base mt-4">{card.description}</p>
              </div>
            ) : (
              <div
                id="description"
                className={`overflow-hidden mb-8 transition-all duration-500 ease-in-out ${
                  activeIndex === index
                    ? "max-h-[400px] opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="flex justify-between">
                  <p className="font-bold text-pretty">
                    {card.descriptionTitle}
                  </p>
                  <p className="text-pretty">{card.price}</p>
                </div>
                <p className="my-4">{card.descritptionSubtitle}</p>
                <p className="text-base my-4">{card.description}</p>
                <p>{card.postScript}</p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
